import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISiteNamedUserModel } from '@apps-common/types/portal/users'

export const QUERY_MY_MONITORING_GET_SYSTEM_USER = (userId?: number, unitId?: string) =>
  ['getMyMonitoringSiteSystemUser', userId, unitId].filter(Boolean)

const getSystemUser = async (unitId: string, userId: number): Promise<ISiteNamedUserModel> =>
  axios.get(`/my-monitoring/sites/GetSystemUser?unitId=${unitId}&userId=${userId}`).then((res) => res.data?.data)

type QueryFnType = typeof getSystemUser

type Props = {
  config?: QueryConfig<QueryFnType>
  userId: number
  unitId: string
}

export const useMyMonitoringGetSystemUser = ({ config, userId, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_MY_MONITORING_GET_SYSTEM_USER(userId, unitId),
    queryFn: () => getSystemUser(unitId, userId)
  })
